import Handsontable from "handsontable";

export const contextMenu = {
    callback: function (key, selection, clickEvent) {
        // Common callback for all options
        console.log(key, selection, clickEvent);
    },
    items: {
        about: {
            // Own custom option
            name: function () {
                // `name` can be a string or a function
                return "<b>แสดงประวัติข้อมูล</b>"; // Name can contain HTML
            },
            hidden: function () {
                // `hidden` can be a boolean or a function
                // Hide the option when the first column was clicked
                return this.getSelectedLast()[1] === 0; // `this` === hot3
            },
            callback: function (key, selection, clickEvent) {
                // Callback for specific option
                setTimeout(function () {
                    alert("Hello world!"); // Fire alert after menu close (with timeout)
                }, 0);
            },
        },
        formula: {
            // Own custom option
            name: function () {
                // `name` can be a string or a function
                return "<b>Formula Setting</b>"; // Name can contain HTML
            },
            hidden: function () {
                // `hidden` can be a boolean or a function
                // Hide the option when the first column was clicked
                return this.getSelectedLast()[1] === 0; // `this` === hot3
            },
            callback: function (key, selection, clickEvent) {
                // Callback for specific option
                setTimeout(function () {
                    alert("Under contruction!"); // Fire alert after menu close (with timeout)
                }, 0);
            },
        },
    },
}

export const sumColumnList = (list,key) => {
    let sum  = 0;
    if(list && list.length > 0 ){
        list.forEach((item)=>{
            let tempSum = item[`${key}`];
            sum +=  (tempSum=== null || tempSum === '')?0:parseInt(tempSum);
        })
    }
    return sum === 0 ?'':sum;
}

export function firstRowRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    td.style.fontWeight = "bold";
    // td.style.color = "green";
    td.style.background = "#d0cece";
    td.style.color = "black";
    // td.style.background = "#d0cece";
    td.style.textAlign = "center";
    td.style.verticalAlign = "middle";
}

export function unitRenderer(instance, td, row, col, prop, value, cellProperties) {

    let unitContract = instance.getDataAtCell(row,4);
    if(value > unitContract){
        td.style.color = "red";
    }
    cellProperties.type = "numeric";
    cellProperties.format = "0.[00]%";

    Handsontable.renderers.NumericRenderer.apply(this, arguments);
}

export function amountRenderer(instance, td, row, col, prop, value, cellProperties) {

    let unitContract = instance.getDataAtCell(row,4);
    let unitVal = instance.getDataAtCell(row,col-1);
    if(unitVal > unitContract){
        td.style.color = "red";
    }
    cellProperties.type = "numeric";
    cellProperties.format = "0.[00]%";

    Handsontable.renderers.NumericRenderer.apply(this, arguments);
}

export function footerRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    td.style.fontWeight = "bold";
    td.style.textAlign = "center";
    td.style.background = "#ffd966";
}

export const columnSummary = (hot) =>{

    if(hot.current && hot.current !== null){

        let hotTable =  hot.current.hotInstance
        let sumRow = hotTable.countRows() - 1;
        
        let colSummaryArr = [];
        let countCols = hotTable.countCols() 
        if(countCols > 0) {
            // sum would be for column 3 onwards
            for(let i = 2; i < countCols; i++) {
                colSummaryArr.push({
                    destinationRow: sumRow,
                    destinationColumn: i,
                    // reversedRowCoords: true,
                    type: 'sum',
                    ranges: [
                    [2, sumRow-1]
                    ],
                })
            }                                       
            return colSummaryArr;
        }
        else {
            return [];
        }
    }else{
        return [];
    }
}